'use client'

import Pagination from '@component/pagination'
import useProgressRouter from '@hooks/useProgressRouter'
import getBuilderRoute from '@plugin/searchRoute/modules/builder'
import { builderList } from '@router'
import { toNumber } from '@utils'
import { useCallback, useMemo } from 'react'

export default function BuilderPagination({
  state,
  totals
}) {

  const { pageSize } = state
  const pageIndex = useMemo(() => {
    const builderRoute = getBuilderRoute()
    builderRoute.fromSlug(state.slug)
    return toNumber(builderRoute.page)
  }, [state])

  const { replaceRouter } = useProgressRouter()
  const changeHandle = useCallback(idx => {
    const { slug } = state
    const builderRoute = getBuilderRoute()
    builderRoute.fromSlug(slug)
    builderRoute.page = idx
    const newSlug = builderRoute.toSlug()
    if (slug !== newSlug) {
      replaceRouter(builderList(newSlug))
    }
  }, [state, replaceRouter])
  return totals > pageSize && (
    <Pagination pageIndex={pageIndex} pageSize={pageSize} totals={totals} center onChange={changeHandle} className='mt-16'></Pagination>
  )
}